<template>
  <div id="sections-saving-throws-index">

    <section>
      <section-header
        @toggle="showSection = !showSection"
        :showSection="showSection"
        :section="section">
        <slot></slot>
      </section-header>

      <div class="content" v-show="showSection">
        <div v-for="savingThrow in savingThrows" :key="savingThrow._id">
          <pfrpg v-if="ruleset === 'PFRPG'"
            :attribute="attribute(savingThrow.attribute)"
            :savingThrow="savingThrow">
          </pfrpg>
          <pfrpg2 v-if="['PF Playtest', 'PFRPG2', 'Embers RPG'].includes(ruleset)"
            :attribute="attribute(savingThrow.attribute)"
            :savingThrow="savingThrow">
          </pfrpg2>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
import { mapState } from "vuex";
import Pfrpg from "./_Pfrpg.vue";
import Pfrpg2 from "./_Pfrpg2.vue";
import SectionHeader from "../shared/_SectionHeader.vue";

export default {
  name: "sections-saving-throws-index",
  components: {
    Pfrpg,
    Pfrpg2,
    SectionHeader,
  },
  data() {
    return {
      section: "savingThrows",
      showSection: true,
    };
  },
  computed: mapState({
    ruleset: (state) => state.characters.current.ruleset,
    attributes: (state) => state.characters.current.attributes,
    savingThrows: (state) => state.characters.current.defense.savingThrows,
  }),
  methods: {
    attribute(val) {
      return this.attributes.find((x) => x.name === val);
    },
  },
};
</script>
